import SvgIcon from 'material-ui/SvgIcon';
import React from 'react';

const CartAdd = (props) => (
  <SvgIcon {...props}>
 <g>
		<polyline fill="none" stroke={props.color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" points="
		1,3.816 5.246,3.816 9.105,15.395 19.912,15.395 23,6.518 	"/>
	
		<circle fill="#FFFFFF" stroke={props.color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" cx="10.456" cy="19.677" r="1.351"/>
	
		<circle fill="#FFFFFF" stroke={props.color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" cx="18.561" cy="19.833" r="1.351"/>
	
		<line fill="none" stroke={props.color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" x1="14" y1="6" x2="14" y2="12"/>
	
		<line fill="none" stroke={props.color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" x1="17" y1="9" x2="11" y2="9"/>
</g>
   </SvgIcon>
);

export default CartAdd;



// WEBPACK FOOTER //
// ./src/icons/CartAdd.jsx